import React from "react";

/**
 * Funeral flyers drop the field titles and read as centered lines of text.
 * The event type name is checked first; the title is the fallback for
 * payloads that don't include the event type.
 */
export const isFuneralEvent = (event) => {
  const typeName =
    event?.event_type?.name ||
    event?.EventType?.name ||
    event?.event_type_name ||
    "";
  if (typeName) return typeName.toLowerCase().includes("funeral");
  return String(event?.title || "").toLowerCase().includes("funeral");
};

/** "Terry & Dante - Red Line", with the line name in the host's colour. */
export const FuneralHostLine = ({ event, formatName }) => {
  const hostName = event?.Host ? formatName(event.Host) : event?.host_name;
  const names = [hostName, event?.CoHost && formatName(event.CoHost)]
    .filter(Boolean)
    .join(" & ");
  const colorName =
    event?.Host?.color_name || event?.host_color_name || event?.color_name || "";
  const hex =
    event?.Host?.hex_code || event?.host_hex_code || event?.hex_code || "#000000";

  if (!names && !colorName) return null;

  return (
    <div className="event-detail-row">
      <span className="event-detail-value">
        {names}
        {names && colorName && " - "}
        {colorName && <span style={{ color: hex }}>{colorName} Line</span>}
      </span>
    </div>
  );
};
